import cn from "@/v2-ui/utils/utils.cn"
import Page, { type PageProps } from "@/v2-backoffice-client/components/page"
import InvitationTable from "@/v2-backoffice-client/invitation/InvitationTable"
import InvitationCreateButton from "@/v2-backoffice-client/invitation/create/InvitationCreateButton"

export type InvitationPageProps = PageProps

function InvitationPage(props: InvitationPageProps) {
  const { className, ...pageProps } = props

  return (
    <Page className={cn("invitation-page", className)} {...pageProps}>
      <Page.Header>
        <Page.Title>Invitations</Page.Title>
        <Page.Header.Actions>
          <InvitationCreateButton />
        </Page.Header.Actions>
      </Page.Header>

      <Page.Content className="flex-1 min-h-0 overflow-auto">
        <InvitationTable />
      </Page.Content>
    </Page>
  )
}

export default InvitationPage
